import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';

import { accountSliceReducer } from './account/account-slice';
import { addressSliceReducer } from './address/address-slice';
import { authSliceReducer } from './auth/auth-slice';
import { authPersistConfig } from './auth/persist-config';
import { errorsSliceReducer } from './errors/errors-slice';
import { orderSliceReducer } from './order/order-slice';
import { requestSliceReducer } from './request/request-slice';

export const rootReducer = combineReducers({
  account: accountSliceReducer,
  address: addressSliceReducer,
  auth: persistReducer(authPersistConfig, authSliceReducer),
  errors: errorsSliceReducer,
  request: requestSliceReducer,
  order: orderSliceReducer,
});
